import type { NetworkPlayerState } from "../net/protocol";
import type { LobbyServerRecord } from "../net/lobby";

interface LobbyScreenProps {
  server: LobbyServerRecord;
  players: NetworkPlayerState[];
  isHost: boolean;
  onLeave: () => void;
  onOpenOptions: () => void;
  onStartMatch?: () => void;
  status?: string | null;
}

export function LobbyScreen({ server, players, isHost, onLeave, onOpenOptions, onStartMatch, status }: LobbyScreenProps) {
  return (
    <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr]">
      <div className="space-y-6">
        <div className="border-b border-white/10 pb-5">
          <div className="font-mono text-sm uppercase tracking-[0.32em] text-white/88">{server.name}</div>
          <div className="mt-2 text-sm text-white/55">{server.mode.toUpperCase()} • {server.mapId} • {players.length}/{server.maxPlayers} pilots</div>
        </div>

        <div className="space-y-4">
          {players.map((player) => (
            <div key={player.id} className="flex items-center justify-between gap-4 border-b border-white/10 pb-3 text-sm text-white/70">
              <div>
                <div className="font-medium text-white">{player.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/35">{player.team ?? "ffa"}</div>
              </div>
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#ffb347]">{player.ready ? "linked" : "syncing"}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-6 border-t border-white/10 pt-6 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0">
        <p className="text-sm leading-7 text-white/60">Host-authoritative P2P transport is online. Pilots are exchanging signaling and data-channel state in the ready room.</p>
        {status ? <div className="border-b border-cyan-300/20 pb-4 text-sm text-cyan-100/85">{status}</div> : null}
        <div className="space-y-4">
          <button type="button" className="font-mono text-[11px] uppercase tracking-[0.34em] text-[#ffb347] transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none disabled:text-white/30" onClick={onStartMatch} disabled={!isHost || !onStartMatch}>
            {isHost ? "Start Match" : "Awaiting Host"}
          </button>
          <button type="button" className="block font-mono text-[11px] uppercase tracking-[0.32em] text-white/60 transition-colors duration-200 hover:text-[#ffb347] focus-visible:outline-none focus-visible:text-[#ffb347]" onClick={onOpenOptions}>
            Options
          </button>
          <button type="button" className="block font-mono text-[11px] uppercase tracking-[0.32em] text-white/60 transition-colors duration-200 hover:text-[#ffb347] focus-visible:outline-none focus-visible:text-[#ffb347]" onClick={onLeave}>
            Leave Lobby
          </button>
        </div>
      </div>
    </div>
  );
}
